import { useState } from "react";
import { Check, Plus, X } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export const Checklist = ({ r }) => {
  const { run } = useApp();
  const [text, setText] = useState("");
  const items = r.checklist || [];
  const save = (checklist) => run(() => api.patch(`/reminders/${r.id}`, { checklist }));
  const add = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    save([...items, { text: text.trim(), done: false }]);
    setText("");
  };
  const done = items.filter((c) => c.done).length;
  return (
    <section data-testid="ticket-checklist">
      <p className="mb-2 flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Checklist {items.length > 0 && <span className="font-mono normal-case" data-testid="checklist-progress">{done}/{items.length}</span>}
      </p>
      {items.length > 0 && <div className="mb-2 h-1 overflow-hidden rounded-full bg-white/5"><div className="h-full bg-emerald-400 transition-[width]" style={{ width: `${(done / items.length) * 100}%` }} /></div>}
      <ul className="space-y-1">
        {items.map((c, i) => (
          <li key={c.id || i} className="group flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-white/[0.03]">
            <button onClick={() => save(items.map((x, j) => (j === i ? { ...x, done: !x.done } : x)))} data-testid={`checklist-toggle-${i}`}
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${c.done ? "border-emerald-400 bg-emerald-400 text-black" : "border-white/25"}`}>
              {c.done && <Check className="h-3 w-3" strokeWidth={3} />}
            </button>
            <span className={`flex-1 text-sm ${c.done ? "text-muted-foreground line-through" : ""}`}>{c.text}</span>
            <button onClick={() => save(items.filter((_, j) => j !== i))} className="opacity-0 transition-opacity group-hover:opacity-100" data-testid={`checklist-remove-${i}`}><X className="h-3.5 w-3.5 text-muted-foreground" /></button>
          </li>
        ))}
      </ul>
      <form onSubmit={add} className="mt-1 flex items-center gap-2 px-2">
        <Plus className="h-3.5 w-3.5 text-muted-foreground" />
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a step" className="h-8 flex-1 bg-transparent text-sm outline-none" data-testid="checklist-add-input" />
      </form>
    </section>
  );
};
